import * as React from 'react';
import { CircleButton, CircleButtonProps } from '@minecraft.atoms';
import { BaseDropdownButton } from './BaseDropdownButton';
import { DropdownItemProps, OptionalProps } from './types';

export interface CircleDropdownButtonProps extends OptionalProps {
  block?: boolean;
  menuAlign?: 'right' | 'left';
  menuChildren?: React.ReactNode;
  menuItemsProps: DropdownItemProps[];
  mobileBlock?: boolean;
  toggleProps: Pick<CircleButtonProps, 'color' | 'size' | 'icon' | 'variant' | 'label' | 'disabled'>;
  /** use "body" to have the menu attach to the document body instead of being set inside the dropdown */
  menuContainer?: 'body' | undefined;
}

export const CircleDropdownButton = ({
  'data-testid': dataTestId,
  block = false,
  className,
  menuAlign = 'right',
  menuChildren,
  menuItemsProps = [],
  mobileBlock = false,
  qaId,
  toggleProps,
  menuContainer,
}: CircleDropdownButtonProps) => (
  <BaseDropdownButton
    block={block}
    className={className}
    data-testid={dataTestId}
    menuAlign={menuAlign}
    menuChildren={menuChildren}
    menuItemsProps={menuItemsProps}
    mobileBlock={mobileBlock}
    qaId={qaId}
    menuContainer={menuContainer}
    toggleChildren={undefined}
    ToggleComponent={CircleButton}
    toggleProps={toggleProps}
  />
);
